export default "__VITE_ASSET__2a6d7ca2__"